// import React, { useState } from "react";
// import emailjs from "@emailjs/browser";

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       // Send email via EmailJS
//       await emailjs.send(
//         "service_7ikoppg", // ✅ your service ID
//         "template_2qbk6xi", // ✅ your template ID
//         {
//           from_name: formData.name,
//           reply_to: formData.email,
//           subject: formData.subject,
//           message: formData.message,
//         },
//         "a5diYV5HVT6bkQTz3" // ✅ your public key
//       );

//       alert("Message sent successfully!");
//       setFormData({ name: "", email: "", subject: "", message: "" });
//     } catch (error) {
//       console.error("Error sending message:", error);
//       alert("Something went wrong. Please try again.");
//     }
//   };

//   return (
//     <>
//      <div className="bg-[#0a1220] text-center py-20 ">
//         <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
//           Get In Touch
//         </h1>
//         <div className="flex justify-center mb-6">
//           <div className="h-2 w-32 rounded-full bg-cyan-400" />
//         </div>
//         <p className="text-gray-300 text-lg">
//           Have questions? We're here to help you keep your car looking its best!
//         </p>
//       </div>
//     <section className="bg-gray-50 py-20">
//       <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10">
//         {/* Left Side Form */}
//         <div className="bg-[#0f172a] p-8 rounded-2xl shadow-xl">
//           <h2 className="text-white text-2xl font-semibold mb-6">Contact Us</h2>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <input
//               name="name"
//               placeholder="Your name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//               required
//             />
//             <input
//               name="email"
//               type="email"
//               placeholder="your@email.com"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//               required
//             />
//             <input
//               name="subject"
//               placeholder="How can we help?"
//               value={formData.subject}
//               onChange={handleChange}
//               className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//               required
//             />
//             <textarea
//               name="message"
//               placeholder="Your message..."
//               value={formData.message}
//               onChange={handleChange}
//               className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700 h-32"
//               required
//             />
//             <button
//               type="submit"
//               className="bg-[#2da8e0] text-white w-full py-3 rounded-lg font-semibold hover:bg-[#2499ce] transition"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>

//         Right Side Info
//         <div className="space-y-5">
//           <h3 className="text-2xl font-semibold text-gray-900 mb-4">
//             Quick Contact Info
//           </h3>
//           <div className="bg-white p-5 rounded-xl shadow-md">
//             <p className="font-semibold text-gray-800">Hours of Operation</p>
//             <p>Mon–Sun, 24 hours</p>
//             {/* <p className="text-[#2da8e0] font-semibold">Always Open!</p> */}
//           </div>
//           <div className="bg-white p-5 rounded-xl shadow-md">
//             <p className="font-semibold text-gray-800">Call Us</p>
//             <a href="tel:5305293002" className="text-black font-medium ">
//               530 529-3002
//             </a>
//           </div>
//           <div className="bg-white p-5 rounded-xl shadow-md">
//             <p className="font-semibold text-gray-800">Email Us</p>
//             <a
//               href="mailto:mainstreetcarwashrb@gmail.com"
//               className=" font-medium"
//             >
//               mainstreetcarwashrb@gmail.com
//             </a>
//           </div>
//           <div className="bg-white p-5 rounded-xl shadow-md">
//             <p className="font-semibold text-gray-800">Visit Us</p>
//             <a
//               href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//               target="_blank"
//               rel="noreferrer"
//               className=" font-medium"
//             >
//               409 Main Street, Red Bluff, CA
//             </a>
//           </div>
//         </div>
//       </div>

    
//     </section>
//     </>
//   );
// }


// import React, { useState } from "react";
// import emailjs from "@emailjs/browser";

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await emailjs.send(
//         "service_7ikoppg",
//         "template_2qbk6xi",
//         {
//           from_name: formData.name,
//           reply_to: formData.email,
//           subject: formData.subject,
//           message: formData.message,
//         },
//         "a5diYV5HVT6bkQTz3"
//       );
//       alert("Message sent successfully!");
//       setFormData({ name: "", email: "", subject: "", message: "" });
//     } catch (error) {
//       console.error("Error sending message:", error);
//       alert("Something went wrong. Please try again.");
//     }
//   };

//   return (
//     <>
//       {/* HEADER */}
//       <div className="bg-[#0a1220] text-center py-20">
//         <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
//           Get In Touch
//         </h1>
//         <div className="flex justify-center mb-6">
//           <div className="h-2 w-32 rounded-full bg-cyan-400" />
//         </div>
//         <p className="text-gray-300 text-lg max-w-2xl mx-auto">
//           Have questions? We're here to help you keep your car looking its best!
//         </p>
//       </div>

//       {/* CONTACT SECTION */}
//       <section className="bg-gray-50 py-20">
//         <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10">
//           {/* LEFT: CONTACT FORM */}
//           <div className="bg-[#0f172a] p-8 rounded-2xl shadow-xl">
//             <h2 className="text-white text-2xl font-semibold mb-6">
//               Contact Us
//             </h2>
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <input
//                 name="name"
//                 placeholder="Your name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//                 required
//               />
//               <input
//                 name="email"
//                 type="email"
//                 placeholder="your@email.com"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//                 required
//               />
//               <input
//                 name="subject"
//                 placeholder="How can we help?"
//                 value={formData.subject}
//                 onChange={handleChange}
//                 className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
//                 required
//               />
//               <textarea
//                 name="message"
//                 placeholder="Your message..."
//                 value={formData.message}
//                 onChange={handleChange}
//                 className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700 h-32"
//                 required
//               />
//               <button
//                 type="submit"
//                 className="bg-[#2da8e0] text-white w-full py-3 rounded-lg font-semibold hover:bg-[#2499ce] transition"
//               >
//                 Send Message
//               </button>
//             </form>
//           </div>

//           {/* RIGHT: QUICK CONTACT INFO */}
//           <div className="space-y-6">
//             <div className="text-left">
//               <h3 className="text-2xl font-extrabold text-[#0a1220]">
//                 Quick Contact Info
//               </h3>
//               <div className="mt-2 h-1.5 w-24 rounded-full bg-cyan-400" />
//             </div>

//             {/* Hours */}
//             <InfoCard
//               icon={<ClockIcon className="h-6 w-6 text-cyan-500" />}
//               title="Hours of Operation"
//               content={
//                 <>
//                   <p>Mon–Sun</p>
//                   <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-cyan-100 px-3 py-1 text-cyan-700 text-sm font-semibold">
//                     <span className="inline-block h-2 w-2 rounded-full bg-cyan-500" />
//                     Open 24/7
//                   </div>
//                 </>
//               }
//             />

//             {/* Phone */}
//             <InfoCard
//               icon={<PhoneIcon className="h-6 w-6 text-cyan-500" />}
//               title="Call Us"
//               content={
//                 <a
//                   href="tel:15305293002"
//                   className="mt-2 inline-flex items-center justify-center rounded-lg bg-cyan-400 px-4 py-2 font-semibold text-[#0a1220] hover:bg-cyan-300 transition"
//                 >
//                   (530) 529-3002
//                 </a>
//               }
//             />

//             {/* Email */}
//             <InfoCard
//               icon={<MailIcon className="h-6 w-6 text-cyan-500" />}
//               title="Email Us"
//               content={
//                 <a
//                   href="mailto:mainstreetcarwashrb@gmail.com"
//                   className="mt-2 inline-block text-cyan-700 font-semibold hover:underline"
//                 >
//                   mainstreetcarwashrb@gmail.com
//                 </a>
//               }
//             />

//             {/* Address */}
//             <InfoCard
//               icon={<MapPinIcon className="h-6 w-6 text-cyan-500" />}
//               title="Visit Us"
//               content={
//                 <>
//                   <a
//                     href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//                     target="_blank"
//                     rel="noreferrer"
//                     className="mt-2 inline-block text-cyan-700 font-semibold hover:underline"
//                   >
//                     409 Main Street, Red Bluff, CA
//                   </a>
//                   <div className="mt-3">
//                     <a
//                       href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
//                       target="_blank"
//                       rel="noreferrer"
//                       className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-4 py-2 font-semibold text-[#0a1220] hover:bg-slate-50 transition"
//                     >
//                       Get Directions
//                     </a>
//                   </div>
//                 </>
//               }
//             />
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// /* --- Helper Components --- */
// function InfoCard({ icon, title, content }) {
//   return (
//     <div className="rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-200">
//       <div className="flex items-start gap-4">
//         <div className="shrink-0 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 ring-1 ring-cyan-100">
//           {icon}
//         </div>
//         <div className="grow">
//           <p className="font-semibold text-[#0a1220]">{title}</p>
//           <div className="mt-1 text-slate-700">{content}</div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* --- Inline SVG Icons --- */
// function ClockIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
//       <path
//         d="M12 7v5l3 2"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }
// function PhoneIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M6.6 10.8a12.9 12.9 0 0 0 6.6 6.6l2.2-2.2a1.5 1.5 0 0 1 1.6-.35l3.3 1.1a1.5 1.5 0 0 1 1 1.41V20a2 2 0 0 1-2.2 2A18 18 0 0 1 2 6.2 2 2 0 0 1 4 4h1.64a1.5 1.5 0 0 1 1.41 1l1.1 3.3c.2.53.06 1.13-.35 1.54L6.6 10.8z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   );
// }
// function MailIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-11Z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//       <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.8" />
//     </svg>
//   );
// }
// function MapPinIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="none" {...props}>
//       <path
//         d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//       <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.8" />
//     </svg>
//   );
// }


import React, { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await emailjs.send(
        "service_7ikoppg",
        "template_2qbk6xi",
        {
          from_name: formData.name,
          reply_to: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "a5diYV5HVT6bkQTz3"
      );
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {/* HEADER */}
      <div className="bg-[#0a1220] text-center py-20">
        <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
          Get In Touch
        </h1>
        <div className="flex justify-center mb-6">
          <div className="h-2 w-32 rounded-full bg-cyan-400" />
        </div>
        <p className="text-gray-300 text-lg max-w-2xl mx-auto">
          Have questions? We're here to help you keep your car looking its best!
        </p>
      </div>

      {/* CONTACT SECTION */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10">
          {/* LEFT: CONTACT FORM */}
          <div className="bg-[#0f172a] p-8 rounded-2xl shadow-xl">
            <h2 className="text-white text-2xl font-semibold mb-6">
              Contact Us
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                name="name"
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
                required
              />
              <input
                name="email"
                type="email"
                placeholder="your@email.com"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
                required
              />
              <input
                name="subject"
                placeholder="How can we help?"
                value={formData.subject}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700"
                required
              />
              <textarea
                name="message"
                placeholder="Your message..."
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-700 h-32"
                required
              />
              <button
                type="submit"
                className="bg-cyan-400 text-[#0a1220] w-full py-3 rounded-lg font-semibold hover:bg-cyan-300 transition"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* RIGHT: QUICK CONTACT INFO */}
          <div className="space-y-6">
            <h3 className="text-2xl font-extrabold text-[#0a1220] mb-4">
              Quick Contact Info
            </h3>

            <SimpleInfoCard
              icon={<ClockIcon className="h-6 w-6 text-cyan-400" />}
              title="Hours of Operation"
              content="Mon–Sun, Open 24 Hours"
            />

            <SimpleInfoCard
              icon={<PhoneIcon className="h-6 w-6 text-cyan-400" />}
              title="Call Us"
              content={
                <a
                  href="tel:15305293002"
                  className="font-semibold text-cyan-400 hover:underline"
                >
                  (530) 529-3002
                </a>
              }
            />

            <SimpleInfoCard
              icon={<MailIcon className="h-6 w-6 text-cyan-400" />}
              title="Email Us"
              content={
                <a
                  href="mailto:mainstreetcarwashrb@gmail.com"
                  className="font-semibold text-cyan-400 hover:underline"
                >
                  mainstreetcarwashrb@gmail.com
                </a>
              }
            />

            <SimpleInfoCard
              icon={<MapPinIcon className="h-6 w-6 text-cyan-400" />}
              title="Visit Us"
              content={
                <a
                  href="https://maps.google.com?q=409+Main+Street,+Red+Bluff,+CA"
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-cyan-400 hover:underline"
                >
                  409 Main Street, Red Bluff, CA
                </a>
              }
            />
          </div>
        </div>
      </section>
    </>
  );
}

/* --- Card Component --- */
function SimpleInfoCard({ icon, title, content }) {
  return (
    <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm ring-1 ring-gray-200">
      <div className="shrink-0">
        <div className="h-11 w-11 rounded-lg flex items-center justify-center bg-cyan-50">
          {icon}
        </div>
      </div>
      <div>
        <p className="font-semibold text-[#0a1220]">{title}</p>
        <div className="text-slate-700 mt-1">{content}</div>
      </div>
    </div>
  );
}

/* --- Icons --- */
function ClockIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 7v5l3 2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
function PhoneIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.6 10.8a12.9 12.9 0 0 0 6.6 6.6l2.2-2.2a1.5 1.5 0 0 1 1.6-.35l3.3 1.1a1.5 1.5 0 0 1 1 1.41V20a2 2 0 0 1-2.2 2A18 18 0 0 1 2 6.2 2 2 0 0 1 4 4h1.64a1.5 1.5 0 0 1 1.41 1l1.1 3.3c.2.53.06 1.13-.35 1.54L6.6 10.8z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}
function MailIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-11Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}
function MapPinIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}
